import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, Signal, inject, signal } from '@angular/core';
import { PinValidator } from '@merchant-portal/app/core/guard/pin.guard.validator';
import { lastValueFrom } from 'rxjs';
import { PinApiService } from '../../../api/pin-api.service';
import { ForgotPinStoreFactory } from '../factory/forgot-pin-store.factory';

@Injectable()
export class ForgotPinDialogStoreService extends ForgotPinStoreFactory {
  private _userStep = signal<'create-pin' | 'confirm-pin' | 'done'>('create-pin');
  override userStep = this._userStep;

  private newPin = '';
  private reEnterNewPin = '';

  private _loading$ = signal(false);
  private _error$ = signal<string | null>(null);

  override loading$: Signal<boolean> = this._loading$;
  override error$: Signal<string | null> = this._error$;
  private apiCall = inject(PinApiService);
  async submitPin(newPin: string, reEnterNewPin: string) {
    if (newPin !== reEnterNewPin) {
      this._error$.set('PIN does not match');
      return null;
    }
    try {
      this._loading$.set(true);
      this._error$.set(null);

      const { data } = await lastValueFrom(this.apiCall.resetPin(newPin));
      return data;
    } catch (error) {
      const httpError: HttpErrorResponse = error as any;
      this._error$.set(httpError?.error?.errors ?? httpError.message ?? 'Unkown Error');
      return null;
    } finally {
      this._loading$.set(false);
    }
  }

  override async next(pin: string): Promise<void> {
    switch (this.userStep()) {
      case 'create-pin':
        this.newPin = pin;
        const validationError = PinValidator.isValidPin(pin);
        if (validationError) {
          this._error$.set(validationError);
          break;
        } else {
          this._error$.set(null);
          this._userStep.set('confirm-pin');
          break;
        }

      case 'confirm-pin':
        this.reEnterNewPin = pin;
        if (this.newPin !== this.reEnterNewPin) {
          this._error$.set('PIN does not match');
          break;
        } else {
          const response = await this.submitPin(this.newPin, this.reEnterNewPin);
          if (response) {
            this._userStep.set('done');
          }
        }
        break;
      default:
        break;
    }
  }
}
